import { PropsWithChildren } from "react";
import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";

import { SignupLink } from "../SignupCodePage/SignupCodePage";
import styles from "./Background.module.css";
import logo from "./logoWhite.png";

const navyPath = (pathname: string) => {
  return /^\/exercise\/.+\/strengths$/.test(pathname);
};

export default function Background({ children }: PropsWithChildren<{}>) {
  const location = useLocation();

  const backgroundClasses = classNames(styles.background, {
    [styles.navy]: navyPath(location.pathname),
  });

  const logOut = () => {
    localStorage.clear();
  };

  const renderLinks = (cn: string) => {
    if (["/login", "/signup"].includes(location.pathname)) return null;

    return (
      <div className={cn}>
        <SignupLink />
        <Link className={`${styles.linkButton}`} to="/profile">
          Profile
        </Link>
        <a
          className={`${styles.linkButton}`}
          href="/login"
          onClick={logOut}
        >
          Log Out
        </a>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Link to="/">
          <img src={logo} alt="Women Doing Well Logo" />
        </Link>
        <div className={styles.right}>
          {renderLinks(styles.desktopLinks)}
          <h4>Integrated Life Purpose Statement</h4>
        </div>
      </div>
      {renderLinks(styles.mobileLinks)}
      <div className={backgroundClasses}>
        <div className={styles.inner}>{children}</div>
      </div>
      <div className={styles.footer}>
        Integrated Life Purpose Assessment℠ is a proprietary tool developed by Women Doing Well and is protected by U.S. copyright, trademark, and trade secret laws. Unauthorized use is not permitted. All rights reserved.
      </div>
    </div>
  );
}
